import {BDLoadingComponent, BDModalComponent, BDProjectsModule, BDSharedModule} from '@brother-apps/brother-dealerapp-shared-lib';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CommonModule, DatePipe} from '@angular/common';
import {CredentialsModalComponent} from './components/credentials-modal-component/credentials-modal.component';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {NgxMaskModule} from 'ngx-mask';
import {OrderByPipe} from './pipes/order.pipe';
import {LabeledClearableInputComponent} from './components/labeled-clearable-input/labeled-clearable-input.component';
import {LabeledSelectDistributorInputComponent} from './components/labeled-select-product-input/labeled-select-distributor-input.component';
import {ModalActionsMenuComponent} from './components/modal-actions-menu/modal-actions-menu.component';
import {SpinnerComponent} from './components/spinner/spinner.component';
import {ForDevelopmentComponent} from './components/for-development/for-development.component';
import {ToastComponent} from './components/toast/toast.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgxMaskModule.forRoot(),
        CdkStepperModule,
        BDSharedModule,
        BDProjectsModule,
    ],
    declarations: [
        CredentialsModalComponent,
        OrderByPipe,
        LabeledClearableInputComponent,
        LabeledSelectDistributorInputComponent,
        ModalActionsMenuComponent,
        SpinnerComponent,
        ForDevelopmentComponent,
        ToastComponent
    ],
    exports: [
        BDLoadingComponent,
        BDModalComponent,
        CredentialsModalComponent,
        OrderByPipe,
        LabeledClearableInputComponent,
        LabeledSelectDistributorInputComponent,
        ModalActionsMenuComponent,
        SpinnerComponent,
        ForDevelopmentComponent,
        ToastComponent
    ],

    providers: [
        DatePipe,
        OrderByPipe,
    ]
})
export class SharedModule {
}
